import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AlertType = 'success' | 'error' | 'information';

@Component({
  selector: 'app-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./alert-modal.css'],
})
export class AlertModal {
  @Input() isOpen = false;
  @Input() title = 'Alert';
  @Input() key!: number;
  @Input() message = 'Something happened.';
  @Input() buttonText = 'OK';
  @Input() isLoading = false;

  @Input() type: AlertType = 'information';

  // ✅ FIXED OUTPUT NAME
  @Output() closed = new EventEmitter<void>();

  onClose() {
    if (!this.isLoading) this.closed.emit();
  }

  get typeClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-green-100 text-green-700';
      case 'error':
        return 'bg-red-100 text-red-700';
      case 'information':
      default:
        return 'bg-blue-100 text-blue-700';
    }
  }

  get buttonClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-green-600 hover:bg-green-700';
      case 'error':
        return 'bg-red-600 hover:bg-red-700';
      case 'information':
      default:
        return 'bg-blue-600 hover:bg-blue-700';
    }
  }
}